var CheckoutPaymentsJs = (function ($) {
    var selectDefaultPaymentMethod = function (defaultPaymentMethod) {
        if($(".payment-method-radios input[type='radio']").is(':checked') === false ){
            $(".payment-method-radios input[type='radio']").filter("[value='"+defaultPaymentMethod+"']").first().trigger("click");
        }
    };
    return {
        selectDefaultPaymentMethod: selectDefaultPaymentMethod
    }
}) (jQuery);

var PaymentCookies = (function ($) {
    var setPaymentCookiesListener = function () {
        var paymentRadioButtons = $("#checkoutOptionsContainer").find("input[name='paymentMethod']:radio");
        $(paymentRadioButtons).each(function () {
            var id = $(this).attr("id");
            $('#' + id).on('click', function () {
                setCookie("paymentMethod", id, 1);
            });
            var additionalDiv = $("#checkoutOptionsContainer").find('#additional' + id);
            var additionalDivInputs = additionalDiv.find("input, select");
            $(additionalDivInputs).each(function () {
                var id = $(this).attr("id");
                $('#' + id).on('change', function () {
                    var value = $(this).val();
                    setCookie("additionalPayment" + id, value, 1);
                });
            });
        });
    };

    var initPaymentCookies = function () {
        var currentRadioButtonId = getCookie("paymentMethod");
        $("#" + currentRadioButtonId).trigger('click');
        var currentAdditionalDiv = $("#checkoutOptionsContainer").find('#additional' + currentRadioButtonId);
        if (typeof currentAdditionalDiv !== 'undefined') {
            var additionalDivInputs = currentAdditionalDiv.find("input, select");
            $(additionalDivInputs).each(function () {
                var id = $(this).attr("id");
                var value = getCookie("additionalPayment" + id);
                $('#' + id).val(value);
            });
        }
    };

    var erasePaymentCookies = function () {
        eraseCookie("paymentMethod");
        erasePaymentAdditionalInputs();
    };

    function erasePaymentAdditionalInputs() {
        var regex = /additionalPayment[a-z]*=/gi;
        var found = document.cookie.match(regex);
        $(found).each(function (index, element) {
            var cookieName = element.slice(0, element.length - 1);
            eraseCookie(cookieName);
        });
    }

    function setCookie(name, value, hours) {
        var expires = "";
        if (hours) {
            var date = new Date();
            date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }

    function eraseCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999;path=/';
    }

    return {
        setPaymentCookiesListener: setPaymentCookiesListener,
        initPaymentCookies: initPaymentCookies,
        erasePaymentCookies: erasePaymentCookies
    }
})(jQuery);

$(document).ready(function() {
    if ($(".payment-method-radios").length > 0) {
        defaultPaymentMethod = $("#defaultPaymentMethod").val();
        CheckoutPaymentsJs.selectDefaultPaymentMethod(defaultPaymentMethod);
        PaymentCookies.initPaymentCookies();
        PaymentCookies.setPaymentCookiesListener();
        $('.checkout-payment-config-views-container input').attr('autocomplete', 'off');
    } else {
        PaymentCookies.erasePaymentCookies();
    }
});